import { render, staticRenderFns } from "./SurveyGroupScreen.vue?vue&type=template&id=8aed0e78&scoped=true"
import script from "./SurveyGroupScreen.vue?vue&type=script&lang=js"
export * from "./SurveyGroupScreen.vue?vue&type=script&lang=js"
import style0 from "./SurveyGroupScreen.vue?vue&type=style&index=0&id=8aed0e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aed0e78",
  null
  
)

export default component.exports